import moment from "moment"
import { useEffect, useRef, useState } from "react"
import { Button, Card, Col, Form, Modal, Row } from "react-bootstrap"
import { withTranslation } from "react-i18next"
import SimpleLoad from "../../loader/SimpleLoad"
import * as Yup from 'yup';
import { Field, Formik } from "formik";
import { getTokenExternal } from "../../utils/getTokenExternal"
import { GET_APPOINTMENT_BY_ID, PARTNER_GET_ACTIVE_SIN_TOKEN, TIPO_DOCUMENTO_PACIENTE_COLOMBIA, UPDATE_APPOINTMENT_SIN_TOKEN } from "../../api/Routes"
import Put from "../../api/Put"
import { getIpPublic } from "../../utils/getIpPublic"
import ConsentimientoTeleSalud from "../../components/autoagendamiento/ConsentimientoTeleSalud"
import Get from "../../api/Get"
import SignatureCanvas from "react-signature-canvas";

function Reasignar({t, cita, initialData, handleNext, setCurrentStep}){
    const [show, setShow] = useState(false)
    const [isSubmitting, setIsSubmiting] = useState(false)
    const [choiceTypeInput, setChoiceTypeInput] = useState('')
    const [checkedTerms, setCheckedTerms] = useState(false)
    const [errors, setErrors] = useState({
        firma: {
            error: false,
            text: ''
        },
        identityDocumentType: {
            error: false,
            text: ''
        },
        documentNumber: {
            error: false,
            text: ''
        },
        fullName: {
            error: false,
            text: ''
        },
        patientRelationship: {
            error: false,
            text: ''
        }
    });
    const sigCanvas = useRef({});
    const [aceptacionAcudiente, setAceptacionAcudiente] = useState(false)
    const [tipoDocumentoOpt, setTipoDocumentoOpt] = useState([])
    const [identityDocumentType, setIdentityDocumentType] = useState('')
    const [documentNumber, setDocumentNumber] = useState('')
    const [fullName, setFullName] = useState('')
    const [tipoPacientes, setTipoPacientes] = useState([])
    const [patientRelationship, setPatientRelationship] = useState('')
    const [dataRecord, setDataRecord] = useState('')
    const clear = () => sigCanvas.current.clear();
    const [allowDoAppt, setAllowDoAppt] = useState(true);

    const shemaValidateStepOne = Yup.object().shape({
        choiceType: Yup.string()
          .required(t('Camporequerido')),        
    });

    const prev = () => {
        handleNext("seleccionarFecha")
    }

    const handleClose = () =>setShow(false)

    const handleMakeAppointment = confirmado => {
        if(confirmado){
            if(checkedTerms){
                //checamos campos requeridos
                let doAppt = allowDoAppt;
                if(sigCanvas.current.isEmpty() || aceptacionAcudiente){
                    const errorCopy = {...errors}
                    if(sigCanvas.current.isEmpty()){
                        errorCopy.firma.error = true;
                        errorCopy.firma.text = 'Firma requerida'
                        doAppt = false;
                    }else{
                        errorCopy.firma.error = false;
                        errorCopy.firma.text = ''
                    }
                    if(fullName === ''){
                        errorCopy.fullName.error = true;
                        errorCopy.fullName.text = 'Campo requerido';
                        doAppt = false;
                    }else{
                        errorCopy.fullName.error = false;
                        errorCopy.fullName.text = ''
                    }
                    if(documentNumber === ''){
                        errorCopy.documentNumber.error = true;
                        errorCopy.documentNumber.text = 'Campo requerido';
                        doAppt = false;
                    }else{
                        errorCopy.documentNumber.error = false;
                        errorCopy.documentNumber.text = ''
                    }
                    if(patientRelationship === ''){
                        errorCopy.patientRelationship.error = true;
                        errorCopy.patientRelationship.text = 'Campo requerido';
                        doAppt = false;
                    }else{
                        errorCopy.patientRelationship.error = false;
                        errorCopy.patientRelationship.text = ''
                    }
                    if(identityDocumentType === ''){
                        errorCopy.identityDocumentType.error = true;
                        errorCopy.identityDocumentType.text = 'Campo requerido';
                        doAppt = false;
                    }else{
                        errorCopy.identityDocumentType.error = false;
                        errorCopy.identityDocumentType.text = ''
                    }
                    setErrors(errorCopy)
                }
                if(doAppt){
                    setIsSubmiting(true)
                    const data = {
                        schedule: {
                            scheduleType:"Online",
                            candidateDoctors : [initialData.doctorId],
                            hourInit: initialData.schedule.hourInit
                        }
                    }            
                    try {
                        async function sendReasigned(){
                            let response = await getTokenExternal({id: 2})
                            if(response.data.access_token){
                                const resp = await Put({url: `${GET_APPOINTMENT_BY_ID}/${cita.id}/reassigned`, data: data, access_token:response.data.access_token, header: true})
                                console.log(resp)
                                if(resp.data.state){
                                    setCurrentStep('reservadoExitosamente')
                                }
                                setIsSubmiting(false)
                            }
                        }
                        sendReasigned()
                    } catch (error) {
                        
                    }
                }
            }
        }else{
            setIsSubmiting(true)
            getIpPublic()
            .then(response=>{
                let data = {
                    id: cita.id,
                    legalWarnings: [{
                        id: cita.legalWarnings.id,
                        acceptPatient: "declined",
                        ipAddress: response,
                        legalWarningType: "InformedConsent",
                        dataRecord: dataRecord,
                    }]
                }
                //console.log(data)
                Put({url: UPDATE_APPOINTMENT_SIN_TOKEN, data: data, header: false})
                .then(response=>{      
                    console.log(response)              
                    if(response.data.state){
                        setIsSubmiting(false)
                        setCurrentStep('declined')
                    }
                })
                .catch(error=>{
                    console.log('error')
                })
            })
        }
    }

    const fetchTipoDocumentoApi = async () => {
        try {
            const response = await Get({url: TIPO_DOCUMENTO_PACIENTE_COLOMBIA, noToken: true});
            setTipoDocumentoOpt(response.data)            
        } catch (error) {
            setTipoDocumentoOpt([])
        }        
    }
    const fetchTipoPacienteApi = async () => {
        try {
            const response = await Get({url: `${PARTNER_GET_ACTIVE_SIN_TOKEN}/${initialData.account.id}`, noToken:  true})
            setTipoPacientes(response.data.data.response)
        } catch (error) {
            setTipoPacientes([])
        }        
    }
    

    useEffect(() => {
        fetchTipoDocumentoApi()
        fetchTipoPacienteApi();
    }, [])

    const getTipoDocumento = (value) =>{
        let arr = tipoDocumentoOpt.filter(el=>el.code==="AS" || el.code==="MS").map(e=>(e.id))
        return arr.includes(parseInt(value))
    }
    const [hasLength, setHasLength] = useState(10)
    const getLengthDN = (code) =>{
        switch(code.toUpperCase()){            
            case 'CE':
                return 12
            case 'CD':
            case 'PA':
            case 'SC':
                return 16
            case 'PE':
                return 15
            case 'RC':
            case 'TI':
                return 11
            case 'CN':
                return 9
            case 'MS':
                return 12
            default:
                return 10;
        }
    }

    const checkValidationDocument = (value) => {
        if(getTipoDocumento(identityDocumentType)){
            setErrors(err=>({
                ...err,
                documentNumber: {
                    error: true,
                    text: 'Campo requerido'
                }
            }))
            setAllowDoAppt(false)
        }else{
            if(value === ''){
                setErrors(err=>({
                    ...err,
                    documentNumber: {
                        error: true,
                        text: 'Campo requerido'
                    }
                }))
                setAllowDoAppt(false)
            }
            else if(value.length < 5){
                setErrors(err=>({
                    ...err,
                    documentNumber: {
                        error: true,
                        text: 'Debe tener una longitud mínima de 5 caracteres'
                    }
                }))
                setAllowDoAppt(false)
            }else if(value.length > hasLength){
                setErrors(err=>({
                    ...err,
                    documentNumber: {
                        error: true,
                        text: `Debe tener una longitud máxima de ${hasLength} caracteres`
                    }
                }))
                setAllowDoAppt(false)
            }else{
                setErrors(err=>({
                    ...err,
                    documentNumber: {
                        error: false,
                        text: ''
                    }
                }))
                setAllowDoAppt(true)
            }
        }
    }

    return (
        <Row>
            <Col>
                <Card>
                    <Card.Header className="text-center">
                        <h5>{t('confirmar_servicio')}</h5>
                    </Card.Header>
                    <Card.Body>
                        <Row>
                            <Col xs="12" md="6">
                                <h4 className="color-blue-dark">{t('informacion_medico')}</h4>
                                <Row>
                                    <Col xs="12" md="12">
                                        <label className="mb-2"><strong>{t('medico')}: </strong>{initialData.doctorName}</label>
                                    </Col>
                                </Row>
                            </Col>
                            <Col xs="12" md="6">
                                <h4 className="color-blue-dark">{t('paciente_informacion')}</h4>
                                <Row>
                                    <Col xs="12" md="12"><label className="mb-2"><strong className="text-capitalize">{t('paciente')}: </strong>{`${initialData.name} ${initialData.middleName} ${initialData.lastName} ${initialData.seccondSurname}`}</label></Col>
                                    <Col xs="12" md="12"><label className="mb-2"><strong>Documento: </strong>{initialData ? `${initialData.identityDocumentType?.code ?? ''} ${initialData.documentNumber}` : '-'}</label></Col>
                                    <Col xs="12" md="12"><label className="mb-2"><strong>{t('Telefono')}: </strong>{initialData ? initialData.phoneNumber : '-'}</label></Col>
                                    <Col xs="12" md="12"><label className="mb-2"><strong>{t('Correoelectronico')}: </strong>{initialData ? initialData.email : '-'}</label></Col>
                                </Row>
                            </Col>
                        </Row>
                        <hr />
                        <Row>
                            <Col>
                                <h4 className="color-blue-dark text-center mb-4">{t('informacion_servicio')}</h4>
                                <Row>
                                    <Col xs="12" md="6">
                                        <Row>
                                            <Col xs="12" md="12"><label className="mb-2"><strong>{t('tipo_servicio')}: </strong>{t('telemedicina')} ({t('videollamada')})</label></Col>
                                            <Col xs="12" md="12"><label className="mb-2"><strong>{t('especialidad')}: </strong>{initialData.especialidadName}</label></Col>
                                            <Col xs="12" md="12"><label className="mb-2"><strong>{t('dia_hora')}: </strong>{moment(initialData.schedule.hourInit, "DD-MM-YYYY HH:mm:ss").format("DD-MM-YYYY HH:mm")}</label></Col>
                                        </Row>
                                    </Col>
                                    <Col xs="12" md="6">
                                        <div className="text-center">
                                            <p className="font-size-08rem">
                                                {t('telemedicina_confirm')} 
                                            </p>                                            
                                            <p className="font-size-08rem">
                                                {t('telemedicina_confirm1')}
                                            </p>
                                            <p className="font-size-08rem">
                                                {t('cancelar_cita_text')}
                                            </p>
                                        </div>
                                    </Col>
                                </Row>
                            </Col>
                        </Row>
                        <Row className="mt-3">                    
                            <Col className="text-right">
                                <Formik
                                    initialValues={initialData}
                                    validationSchema={shemaValidateStepOne}
                                    onSubmit={(values)=>{
                                        console.log(values)
                                        setChoiceTypeInput(values.choiceType)
                                        setShow(true)
                                    }}
                                    >{({
                                        errors,
                                        handleSubmit,
                                        setFieldValue,
                                        setFieldError
                                    })=>(
                                        <Form onSubmit={handleSubmit}>
                                            <div>
                                                <label className="d-block font-weight-bold mr-5">{t('dia_hora_debido_a')}:</label>
                                                <label className={`mr-5 text-color-input d-block ${errors.choiceType ? 'color-red' : ''}`}>
                                                    {t('consulta_mas_cerca')}
                                                    <Field 
                                                        type="radio"
                                                        name="choiceType"
                                                        value="closerAppointment"
                                                        className="ml-3 radio-form"
                                                    />
                                                </label>
                                                <label className={`mr-5 text-color-input ${errors.choiceType ? 'color-red' : ''}`}>
                                                    {t('cita_mejor_adapta')}
                                                    <Field 
                                                        type="radio"
                                                        name="choiceType"
                                                        value="preferAppointment"
                                                        className="ml-3 radio-form"
                                                    />
                                                </label>
                                                { errors.choiceType && <div className="invalid-feedback d-block">{errors.choiceType}</div> }
                                            </div>
                                            <div className="mt-4">
                                                <Button type="button" variant="light" onClick={prev}>{t('regresar')}</Button>{' '}
                                                <Button type="submit" variant="primary">{t('confirmar')}</Button>
                                            </div>
                                            
                                        </Form>
                                    )}
                                </Formik>                        
                            </Col>
                        </Row>
                    </Card.Body>
                </Card>
            </Col>
            <Modal show={show} onHide={handleClose} centered className="border-0" size="lg">
                <Modal.Body className="p-2">                    
                    <div className="position-relative overflow-hidden">
                        {isSubmitting && <SimpleLoad />}
                        <h5 className="text-uppercase">{t('consentimiento_telesalud')}</h5>
                        <hr /> 
                        <ConsentimientoTeleSalud
                            namePaciente={`${initialData.name} ${initialData.middleName} ${initialData.lastName} ${initialData.seccondSurname}`}
                            noDocumento={`${initialData.identityDocumentType?.code} ${initialData.documentNumber ? `: ${initialData.documentNumber}` : ''}`}
                            nameDoctor={initialData.doctorName}
                            nameAccount={initialData.account.name}
                            initialData={{
                                ...initialData,
                                identityDocumentTypeModel: initialData.identityDocumentType
                            }}
                            setDataRecord={setDataRecord}
                        /> 
                        <Row>
                            <Col xs="12" md={{span: 6, offset: 3}}>
                                <div className="border">
                                    <SignatureCanvas
                                        penColor='blue'
                                        ref={sigCanvas}
                                        canvasProps={{width: 500, height: 200, border: '1px solid #000'}} 
                                    />
                                    {errors.firma.error && <span className="text-danger">{errors.firma.text}</span>}
                                </div>
                                <div className="w-100 text-right">
                                    <Button 
                                        variant="outline-secondary" 
                                        onClick={clear}
                                        size="sm"
                                        >Limpiar
                                    </Button>
                                </div>
                                
                            </Col>
                        </Row>
                        <div>
                            <Form.Check 
                                className="color-354052 font-size-08rem font-weight-bold-600"
                                type="checkbox"
                                label="Aceptación de consentimiento por acudiente"
                                checked={aceptacionAcudiente}
                                onChange={e=>{
                                    setAceptacionAcudiente(e.target.checked)
                                    if(!e.target.checked){
                                        setIdentityDocumentType('')
                                        setDocumentNumber('')
                                        setPatientRelationship('')
                                        setFullName('')
                                    }
                                }}
                            />
                        </div>
                        {
                                aceptacionAcudiente &&
                                <Row>
                                    <Col xs="12" md="6">
                                        <Form.Group>
                                            <Form.Label className="font-weight-bold-600 text-secondary">{t('tipo_documento')} <span className="text-danger">*</span></Form.Label>
                                            <Form.Control 
                                                as="select"
                                                className={`input-form ${errors.identityDocumentType.error && 'error'}`}
                                                value={identityDocumentType}
                                                onChange={e=>{
                                                    setIdentityDocumentType(e.target.value) 
                                                    let aux = tipoDocumentoOpt.filter(el=>el.id===parseInt(e.target.value))[0]
                                                    setHasLength(getLengthDN(aux.code))                                     
                                                }}
                                            >
                                                <option value="">{t('Seleccionar')}</option>
                                                {
                                                    tipoDocumentoOpt.map((item,i)=>(
                                                        <option value={item.id} key={i}>{`${item.code} : ${item.name}`}</option>
                                                    ))
                                                }                                                
                                            </Form.Control>                                                                              
                                            { errors.identityDocumentType.error && <div className="invalid-feedback d-block">{errors.identityDocumentType.text}</div> }
                                        </Form.Group>
                                    </Col>
                                    <Col xs="12" md="6">
                                        <Form.Group>
                                            <Form.Label className="font-weight-bold-600 text-secondary">{t('documento_identidad')} <span className="text-danger">*</span></Form.Label>
                                            <Form.Control 
                                                type="text"
                                                className={`input-form ${errors.documentNumber.error && 'error'}`}
                                                name={documentNumber}
                                                onChange={e=>setDocumentNumber(e.target.value)}
                                                onBlur={e=>checkValidationDocument(e.target.value)}
                                            />
                                            { errors.documentNumber.error && <div className="invalid-feedback d-block">{errors.documentNumber.text}</div> }
                                        </Form.Group>
                                    </Col>
                                    <Col xs="12" md="6">
                                        <Form.Group>
                                            <Form.Label className="font-weight-bold-600 text-secondary">Nombre completo <span className="text-danger">*</span></Form.Label>
                                            <Form.Control 
                                                type="text"
                                                className={`input-form text-uppercase ${errors.fullName.error && 'error'}`}
                                                name={fullName}
                                                onChange={e=>setFullName(e.target.value.toUpperCase())}
                                            />
                                            { errors.fullName.error && <div className="invalid-feedback d-block">{errors.fullName.text}</div> }
                                        </Form.Group>
                                    </Col>
                                    <Col xs="12" md="6">
                                        <Form.Group>
                                            <Form.Label className="font-weight-bold-600 text-secondary">Parentesco <span className="text-danger">*</span></Form.Label>
                                            <Form.Control 
                                                as="select"
                                                className={`input-form ${errors.patientRelationship.error && 'error'}`}
                                                name={patientRelationship}
                                                onChange={e=>setPatientRelationship(e.target.value)}
                                            >
                                            <option value="">Seleccionar</option>
                                            {
                                                tipoPacientes.map((item,i)=>(
                                                    <option key={i} value={item.id}>{item.name}</option>
                                                ))
                                            }
                                        </Form.Control>
                                        { errors.patientRelationship.error && <div className="invalid-feedback d-block">{errors.patientRelationship.text}</div> }
                                        </Form.Group>
                                    </Col>
                                </Row>
                            }




                        <div className="mt-3">
                            <Form.Group className="text-center">
                                <Form.Check type="checkbox" label={t('acepto')} className="checked-terms" onChange={e=>setCheckedTerms(e.target.checked)} />
                            </Form.Group>
                        </div>

                        <Row className="text-center">
                            <Col>
                                <Button variant="link" className="text-danger font-weight-bold" onClick={e=>handleMakeAppointment(false)}>{t('declinar')}</Button>{' '}
                                <Button 
                                    variant="outline-success" 
                                    className="ok-buttom" 
                                    onClick={e=>handleMakeAppointment(true)}
                                    disabled={!checkedTerms}
                                    >{t('aceptar')}</Button>
                            </Col>
                        </Row>  
                    </div>                                   
                </Modal.Body>
            </Modal>
        </Row>
    )
}

export default withTranslation()(Reasignar)